import React,{Component} from 'react';
import Navbar from '../../Navbar/Navbar';
import './gram.css';

class Sandhi extends Component{

    componentDidMount(){
        window.scrollTo(0, 0);
    }

    render(){
        return(
            <div className="gramTop">
            <Navbar />
            <div className="foo">
                
                                <h1 className="paragraph">सन्धिः</h1>
                            सन्धि शब्द की व्युत्पत्ति – सम् उपसर्ग पूर्वक डुधाञ् (धा) धातु से “उपसर्गे धोः किः” सूत्र से ‘कि’ प्रत्यय करने पर ‘सन्धि’ शब्द निष्पन्न होता है। सन्धि की परिभाषा – वर्ण सन्धान को सन्धि कहते हैं। अर्थात् दो वर्गों के परस्पर के मेल अथवा सन्धान को सन्धि कहा जाता है।

                <br/><br/>पाणिनीय परिभाषा – “परः सन्निकर्षः संहिता” अर्थात् वर्णों की अत्यधिक निकटता को संहिता कहा जाता है। जैसे—’सुधी + उपास्य’ यहाँ ‘ई’ तथा ‘उ’ वर्गों में अत्यन्त निकटता है। इसी प्रकार की वर्गों की निकटता को संस्कृत – व्याकरण में संहिता कहा जाता है। संहिता के विषय में ही सन्धि – कार्य होने पर ‘सुध्युपास्य’ शब्द की सिद्धि होती है।

                <br/><br/>सन्धि के भेद – संस्कृत व्याकरण में सन्धि के तीन भेद होते हैं। वे इस प्रकार हैं –
                <br/><br/>
                <ol>
                <li><h3 className="paragraph">स्वर सन्धि – अच् संधि</h3>
                जब दो स्वरों का सन्धान अथवा मेल होता है, तब वह सन्धान स्वर – सन्धि या अच् सन्धि कही जाती है। यहाँ अच् – सन्धि में स्वर के स्थान पर आदेश होता है। स्वर – सन्धियाँ आठ प्रकार की होती हैं। जैसे –
                <br/>
                <br/>
                <ul>
                <li>अ + अ = आ – पुष्प + अवली = पुष्पावली</li>
                <li>अ + आ = आ – हिम + आलय = हिमालय</li>
                <li>आ + अ = आ – माया + अधीन = मायाधीन</li>
                <li>आ + आ = आ – विद्या + आलय = विद्यालय</li>
                <li>इ + इ = ई – कवि + इच्छा = कवीच्छा</li>
                <li>इ + ई = ई – हरी + ईश = हरीश</li>
                <li>इ + इ = ई – मही + इन्द्र = महीन्द्र</li>
                <li>इ + ई = ई – नदी + ईश = नदीश</li>
                <li>उ + उ = ऊ – सु + उक्ति = सूक्ति</li>
                <li>उ + ऊ = ऊ – सिन्धु + ऊर्मि = सिन्धूमि</li>
                <li>ऊ + उ = ऊ – वधू + उत्सव = वधूत्सव</li>
                <li>ऊ + ऊ = ऊ – भू + ऊर्ध्व = भूल</li>
                <li>ऋ+ ऋ = ऋ – मात + ऋण = मातण</li>

                </ul>
                <br/>
                <br/>
                स्वर सन्धि मे सन्धियाँ 7 प्रकार की होती हैं-
                <ul>
                <li><u>यण – सन्धि </u>: ‘इको यणचि’ सूत्र द्वारा संहिता के विषय में अच् (स्वर) परे रहने पर ‘इक्’ के स्थान पर ‘यण’ होता है। माहेश्वर सूत्र के अनुसार ‘इ/ई, उ/ऊ, ऋ/ऋ , लु’_ये वर्ण ‘इक्’ वर्ण कहलाते हैं। इसी प्रकार ‘य, व, र, ल’—इन वर्गों को ‘यण’ वर्ण कहते हैं। अतः इक् वर्गों के स्थान पर जहाँ क्रमशः यण वर्ण होते हैं, वहाँ ‘यण् सन्धि‘ होती है। </li>
                <br/>
                <li><u>अयादि सन्धि</u>:“एचोऽयवायावः” सत्र द्वारा संहिता के विषय में अच (कोई भी असमान स्वर) सामने होने पर ‘एच’ (ए, ओ, ऐ, औ) के स्थान पर क्रमशः अयादि संधि (अय्, अव्, आय, आव्) आदेश होते हैं।</li>
                <br/>
                <li><u>गुण – सन्धि</u>:‘आद्गुणः’ सूत्र द्वारा (स्वर) संहिता के विषय में अ/आ वर्ण से परे इ/ई, उ/ऊ, ऋ/ऋ, लु वर्गों में से कोई वर्ण होने पर पूर्व – पर वर्गों के स्थान पर गुण संधि एकादेश (अ, ए, ओ) होता है।</li>
                <br/>
                <li><u>वृद्धि सन्धि</u>:‘वृद्धिरेचि’ सूत्र द्वारा संहिता के विषय में अ/आ वर्ण से परे ‘एच’ (ए, ओ, ऐ, औ) (स्वर) होने पर पूर्व एवं पर के स्थान पर वृद्धि संधि एकादेश (आ, ऐ, औ) होते हैं। </li>
                <br/>
                <li><u>सवर्णदीर्घ सन्धि</u>:‘अकः सवर्णे दीर्घः’ सूत्र द्वारा संहिता के विषय में ‘अक्’ प्रत्याहार (अ, इ, उ, ऋ, लु) से परे सवर्ण अच् (स्वर) होने पर पूर्व – पर वर्णों के स्थान पर दीर्घ सन्धि एकादेश होता है।</li>
                <br/>
                <li><u>पूर्वरूप सन्धि</u>:‘एङः पदान्तादति’ सूत्र द्वारा संहिता के विषय में यदि पद के अन्त में एङ् (ए, ओ) (स्वर) आए और उसके बाद ह्रस्व ‘अ’ आए तो पूर्व एवं पर वर्गों के स्थान पर पूर्वरूप संधि एकादेश होता है, तथा अकार की स्पष्ट प्रतीति के लिए अवग्रह चिह्न (ऽ) हो जाता है।</li>
                <br/>
                <li><u>पररूप सन्धि</u>: ‘एङि पररूपम्’ सूत्र द्वारा यदि अकारान्त उपसर्ग के बाद एङ् (स्वर) (ए, ओ) स्वर जिसके प्रारम्भ में हो ऐसी धातु आए तो दोनों स्वरों (पूर्व – पर) के स्थान पर पररूप संधि एकादेश अर्थात् क्रमशः ए और औ हो जाता है।</li>
                <br/>
                </ul>
                </li>
                <br/><br/>
                <li><h3 className="paragraph"> व्यजन सन्धि – हल् संधि</h3>
                व्यंजन के साथ व्यंजन या स्वर का मेल होने से जो विकार होता है, उसे व्यंजन सन्धि कहते हैं। व्यंजन सन्धि के प्रमुख नियम इस प्रकार हैं-
                <br/><br/>
                यदि स्पर्श व्यंजनों के प्रथम अक्षर अर्थात् क्, च्, ट्, त्, के आगे कोई स्वर अथवा किसी वर्ग का तीसरा या चौथा वर्ण अथवा य, र, ल, व आए तो क.च.ट. त. पके स्थान पर उसी वर्ग का तीसरा अक्षर अर्थात क के स्थान पर ग, च के स्थान पर ज, ट के स्थान पर ड, त के स्थान पर द और प के स्थान पर ‘ब’ हो जाता है जैसे-
                <br/><br/>
                <ul>
                <li>दिक् + अम्बर = दिगम्बर</li>
                <li>वाक् + ईश = वागीश</li>
                <li>अच् + अन्त = अजन्त</li>
                <li>षट् + आनन = षडानन</li>
                <li>सत् + आचार = सदाचार</li>
                <li>सुप् + सन्त = सुबन्त</li>
                <li>उत् + घाटन = उद्घाटन</li>
                <li>तत् + रूप = तद्रूप</li>
                </ul>
                <br/>
                व्यंजन संधि मे सन्धियाँ 6 प्रकार की होती हैं-
                <ul>
                <li><u>श्चत्व सन्धि</u>:“स्तोः श्चुना श्चः” सूत्र से जब सकार और तवर्ग (व्यंजन) (स, त्, थ्, द्, ध्, न्) वर्गों के पहले अथवा बाद में शकार और चवर्ग (श्, च्, छ्, ज, झ्, ञ्) वर्ण आते हैं, तब सकार एवं तवर्ग के स्थान पर शकार एवं चवर्ग वर्ण क्रमशः होते हैं। अर्थात् स्, त्, थ्, द्, ध्, न् के स्थान पर क्रमशः श्, च, छ, ज, झ, ञ् वर्ण होते हैं। </li>
                <br/>
                <li><u>ष्टुत्व सन्धि</u>:‘ष्टुना ष्टुः।’ सूत्र से जब सकार एवं तवर्ग वर्गों से पहले (व्यंजन) अथवा बाद में षकार एवं टवर्ग वर्ण आते हैं तो सकार व तवर्ग (स्, त्, थ्, द्, ध्, न्) वर्गों के स्थान पर क्रमशः षकार एवं टवर्ग (ष, ट, ठ, ड्, द, ण) वर्ण होते हैं।</li>
                <br/>
                <li><u>जश्त्व सन्धि</u>: ‘झलां जशोऽन्ते।’ सूत्र द्वारा पदान्त झल् प्रत्याहार के अन्तर्गत वर्षों (वर्ग के 1, 2, 3, 4 वर्ण तथा श् ष स ह वर्णों) के स्थान पर जश् (व्यंजन) (ज् ब् ग् ड् द्) वर्ण होते हैं। </li>
                <br/>
                <li><u>चर्व सन्धिः</u>: ‘खरि च।’ सूत्र द्वारा खर् वर्ण (व्यंजन) (वर्ग के 1, 2, श् ष्, स्) परे होने पर झल वर्णों (वर्ग के 1, 2, 3, 4, श, ष, स्, ह) के स्थान पर चर् वर्ण (क्, च्, ट्, त्, प्, श्, स्) होते हैं।</li>
                <br/>
                <li><u>अनुस्वार</u>‘मोऽनुस्वारः।’ सूत्र द्वारा पदान्त मकार के स्थान पर अनुस्वार आदेश होता है, यदि सामने कोई व्यंजन हो तो।</li>
                <br/>
                <li><u>परसवर्ण सन्धिः</u>:‘यरोऽनुनासिकेऽनुनासिको वा’ – यदि पद के अन्त में यर् (ह को छोड़कर शेष सभी व्यंजन) आए और उसके बाद अनुनासिक (ञ् म् ङ् ण् न्) आए तो यर् के स्थान पर विकल्प से अनुनासिक हो जाता है</li>
                <br/>
                </ul>
                <br/><br/>
                </li>
                <li><h3 className="paragraph">विसर्ग सन्धि</h3>

                जब विसर्ग के स्थान पर कोई भी परिवर्तन होता है, तब उसे विसर्ग – सन्धि कहा जाता है। विसर्गों का प्रयोग संस्कृत को छोड़कर संसार की किसी भी भाषा में नहीं होता है। हिन्दी में भी विसर्गों का प्रयोग नहीं के बराबर होता है। कुछ इने-गिने विसर्गयुक्त शब्द हिन्दी में प्रयुक्त होते हैं;
                जैसे-अत:, पुनः, प्रायः, शनैः शनैः आदि।हिन्दी में मनः, तेजः, आयुः, हरिः के स्थान पर मन, तेज, आयु, हरि शब्द चलते हैं, इसलिए यहाँ विसर्ग सन्धि का प्रश्न ही नहीं उठता। फिर भी हिन्दी पर संस्कृत का सबसे अधिक प्रभाव है। संस्कृत के अधिकांश विधि निषेध हिन्दी में प्रचलित हैं। विसर्ग सन्धि के ज्ञान के अभाव में हम वर्तनी की अशुद्धियों से मुक्त नहीं हो सकते। अत: इसका ज्ञान होना आवश्यक है।
                <br/><br/>
                <ul>
                <li>निः + शंक = निश्शंक</li>
                <li>दुः + शासन = दुश्शासन</li>
                <li>निः + सन्देह = निस्सन्देह</li>
                <li>नि: + संग = निस्संग</li>
                <li>निः + शब्द = निश्शब्द</li>
                <li>निः + स्वार्थ = निस्स्वार्थ</li>
                </ul>
                <br/>
                विसर्ग – संधि मे सन्धियाँ 4 प्रकार की होती हैं-

                <ul>
                <li><u>सत्व सन्धि</u></li>

                <li><u>उत्व सन्धि</u></li>

                <li><u>रुत्व सन्धि</u></li>

                <li><u>लोप सन्धि</u></li>
                </ul>
                </li>
                </ol>
            </div>
            </div>
        )
    }
}

export default Sandhi;